import React, { useContext } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import Login from './pages/Login';
import AuthContext from './context/AuthContext';
import theme from './theme/theme';
import Frame from './pages/Frame/Frame';
import DeleteAccountPublic from './pages/AccountDeletion/DeleteAccountPublic';
import { PermissionProvider } from './context/PermissionContext';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/login" element={<PublicRoute />} />
        <Route path="/delete-account" element={<DeleteAccountPublic />} />
        <Route path="/*" element={<ProtectedRoutes />} />
      </Routes>
    </ThemeProvider>
  );
};

const PublicRoute = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  return isAuthenticated ? <Navigate to={location.state?.from || '/'} /> : <Login />;
};

const ProtectedRoutes = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  return isAuthenticated ? (
    <PermissionProvider>
      <Frame />
    </PermissionProvider>
  ) : (
    <Navigate to="/login" state={{ from: location.pathname }} />
  );
};

export default App;
